<style scoped lang="scss">
  .recruit{
    .title{
      font-size: 36px;
      font-weight: bold;
      margin-top: 30px;
    }
    .resource{
      color: #999;
      margin-top: 10px;
      span{
        margin-right:40px;
      }
    }
    .context{
      h3{
        font-size: 24px;
        margin-top: 40px;
        margin-bottom: 5px;
      }
      p{
        line-height: 2;
        font-size: 16px;
      }
    }
    .send-box{
      background: #E8F5F5;
      text-align: center;
      font-size: 24px;
      color: #014492;
      font-weight: bold;
      padding:40px 0;
      margin-top: 40px;
      line-height: 2;
    }
  }
</style>
<template>
  <section class="recruit">
    <div class="container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/summary/join_us' }">加入擎科</el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="title">{{detail.job.name}}</div>
      <div class="resource"><span>工作地点：{{detail.location.name}}</span><span>时间：{{detail.createTime | rTime}}</span></div>
      <div class="context">
        <div class="mt20" v-html="detail.job.content"></div>
<!--        <h3>岗位描述</h3>-->
<!--        <p>1、主要协助研发主管进行PCR相关产品（如taq酶，PCR MIX，载体等）的研究，开发及性能优化工作；</p>-->
      </div>
      <div class="send-box">
        <p>职位申请请将简历发送至</p>
        <p>{{detail.location.emailFirst}}<span v-show="detail.location.emailSecond && detail.location.emailSecond !== ''">或{{detail.location.emailSecond}}</span></p>
        <p>备注：姓名+申请岗位</p>
      </div>
    </div>
  </section>
</template>

<script>
import { recruitJobs } from '@/services/api.index'
export default {
  data () {
    return {
      detail: {}
    }
  },
  created() {
    this.getLists()
  },
  methods: {
    // 招聘列表
    getLists () {
      const id = this.$route.query.id
      const locationId = this.$route.query.locationId
      recruitJobs('', 0, 100).then(res => {
        res.data.map(item => {
          if (item.job.id === parseInt(id) && item.location.id === parseInt(locationId)) {
            item.createTime = item.createTime.replace(/T/g, ' ').replace(/Z/g, '')
            this.detail = item
          }
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/recruit.vue